import Yup from '../../../helpers/custom-yup'
import styled from 'styled-components'
import Browser from '../../../services/Browser'
import PropTypes from 'prop-types'
import RadioButton from '../radio-button.component'
import ReactTooltip from 'react-tooltip'
import FontAwesome from 'react-fontawesome'
import bradescoLogo from '../../../../assets/icons/bradesco_logo.png'
import bradescoLogoPB from '../../../../assets/icons/bradesco_logo_pb.png'
import DebitCardFields from '../debit-cards-fields/debit-card-fields.component'
import CreditCardFields from '../credit-card-fields/credit-card-fields.component'
import MuvicardFields from '../muvicard-fields/muvicard-fields.component'
import MuvicardOneClick from '../muvicard-oneclick/muvicard-oneclick.component'
import bancoDoBrasilLogo from '../../../../assets/icons/banco_do_brasil_logo.png'
import bancoSantanderLogo from '../../../../assets/icons/santander_logo_copleto.png'
import bancoDoBrasilLogoPB from '../../../../assets/icons/banco_do_brasil_logo_pb.png'
import SaveCreditCardFields from '../credit-card-fields/save-credit-card-fields.component'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { isMobile } from '../../../helpers'
import { PrinterIcon } from '../../custom-icons/printer-icon.component'
import { toastActions } from '../../../actions/toast.actions'
import { dateHelper } from '../../../helpers/date.helper'
import { CalendarIcon } from '../../custom-icons/calendar-icon.component'
import { StyledContent } from './styled-content.style'
import { OnlinePayIcon } from '../../custom-icons/online-pay-icon.component'
import { StyledBillingInfo } from './StyledBillingInfo.style'
import { creditCardsActions } from '../../../actions'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import MuvicardLogo from '../../../../../client/assets/images/logo-muvicard.png'
import PixLogo from '../../../../../client/assets/images/logo-pix.png'
import { Link } from 'react-router-dom'
import { SystemConfigService } from '../../../services/system-config.service'
import { UserService } from '../../../services'
import {
	routes,
	cardBrand,
	breakpoints,
	RoleConstants,
	PAYMENT_METHODS
} from '../../../constants'

const styleForSinglePaymentMethod = `
	& > * {
		width: 200px;
	}

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		width: 200px;
	}
`

const StyledPaymentMethodsButtons = styled.div`
	display: flex;
	grid-auto-flow: column;
	grid-auto-columns: 1fr;
	grid-column-gap: ${({ gap }) => (gap ? gap : '0')};
	flex-wrap: nowrap;

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		flex-direction: column;
	}

	/* @media screen and (min-width: ${breakpoints.MOBILE}px) {
		display: '${Browser.isIE() ? 'flex' : 'grid'};'
	} */

	& > * {
		flex: 1;
		max-width: ${({ isCardBrands }) =>
		isCardBrands ? 'calc((100% / 5) - 31.3px)' : null};
		min-height: 110px;
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			max-width: none;
			max-width: 200px;
			margin-right: 10px;
		}

		&:not(:first-child) {
			margin-left: ${({ gap }) => (Browser.isIE() ? '15px' : gap ? 'unset' : '-1px')};
		}
	}

	.billing-info {
		font-size: 1.3rem;
		font-weight: bold;
		span {
			font-size: 1rem;
			font-weight: initial;
		}
	}

	${({ availablePaymentMethods }) =>
		availablePaymentMethods == 1 ? styleForSinglePaymentMethod : ''};

	.billing {
		font-weight: bold;
		font-size: 2rem;
		span {
			font-weight: initial;
			font-size: 1.7rem;
		}
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			font-size: 1.3rem;
			span {
				font-size: 1rem;
			}
		}
	}
`

const handleRequiredByPaymentMethod = (type, message) =>
	Yup[type]().when('paymentMethod', {
		is: 'creditCard',
		then: Yup[type]().required(message),
		otherwise: Yup[type]()
	})

const handleRequiredByPaymentMethodMuvicard = (type, message) =>
	Yup[type]().when('paymentMethod', {
		is: 'muvicard',
		then: Yup[type]().required(message),
		otherwise: Yup[type]()
	})

export const getMethodPayment = value => {
	if (!value || value !== undefined)`${value}`
}

export const paymentFieldsYupSchemaNoPaymentMethod = {
	cardBrand: Yup.string().required('Informe a bandeira do cartão'),
	installments: Yup.string().required('Informe o número de parcelas'),
	cardPrintedName: Yup.string().required('Informe o nome impresso no cartão'),
	cardNumber: Yup.string()
		.min(16, 'O número deve ter no mínimo 16 caracteres')
		.required('Informe o número do cartão'),
	cardMonthValidity: Yup.string().required('Informe o mês de validate'),
	cardYearValidity: Yup.string().required('Informe o ano de validade'),
	securityCode: Yup.string()
		.required('Informe o código de segurança')
		.min(3, 'O código deve ter no mínimo 3 caracteres')
}

export const paymentFieldsYupSchemaNoInstallments = {
	cardBrand: handleRequiredByPaymentMethod(
		'string',
		'Informe a bandeira do cartão'
	),
	cardPrintedName: Yup.string().when('paymentMethod', {
		is: 'creditCard',
		then: Yup.string().required('Informe o nome impresso no cartão'),
		otherwise: Yup.string().name()
	}),
	cardNumber: handleRequiredByPaymentMethod(
		'string',
		'Informe o número do cartão'
	).when('cardBrand', {
		is: cardBrand.amex,
		then: Yup.string().min(15, 'O número deve ter no mínimo 15 caracteres'),
		otherwise: Yup.string().min(
			16,
			'O número deve ter no mínimo 16 caracteres'
		)
	}),
	cardMonthValidity: handleRequiredByPaymentMethod(
		'number',
		'Informe o mês de validade'
	),
	cardYearValidity: handleRequiredByPaymentMethod(
		'string',
		'Informe o ano de validade'
	),
	securityCode: handleRequiredByPaymentMethod(
		'string',
		'Informe o código de segurança'
	).min(3, 'O código deve ter no mínimo 3 caracteres'),
	paymentMethod: Yup.string().required('Selecione um método de pagamento')
}

export const paymentFieldsMuvicardYupSchemaNoInstallments = {
	password: Yup.string().required('Informe a sua senha'),
	paymentMethod: Yup.string().required('Selecione um método de pagamento')
}

export const paymentFieldsYupSchemaRecurrent = {
	recurrentPayDay: Yup.string().required(
		'Selecione o dia mensal de pagamento'
	),
	...paymentFieldsYupSchemaNoInstallments
}

export const paymentFieldsYupSchema = {
	installments: handleRequiredByPaymentMethod(
		'string',
		'Informe o número de parcelas'
	).nullable(),
	...paymentFieldsYupSchemaNoInstallments
}

export const paymentMuvicardFieldsYupSchema = {
	installments: handleRequiredByPaymentMethodMuvicard(
		'string',
		'Informe o número de parcelas'
	).nullable(),

	muvicardCpf: handleRequiredByPaymentMethodMuvicard(
		'string',
		'Informe o cpf do comprador'
	).nullable(),
	...paymentFieldsMuvicardYupSchemaNoInstallments
}
export const paymentMuvicardOneClickYupSchema = {
	installments: handleRequiredByPaymentMethodMuvicard(
		'string',
		'Informe o número de parcelas'
	).nullable(),
	paymentMethod: Yup.string().required('Selecione um método de pagamento')
}

export const paymentFieldsInitialValues = ({ installments, recurrent }) => {
	const initialValues = {
		paymentMethod: 'creditCard',
		cardBrand: cardBrand.mastercard,
		cardPrintedName: '',
		cardNumber: '',
		cardMonthValidity: '',
		cardYearValidity: '',
		securityCode: '',
		selectsavecard: true,
		cardNumberToken: '',
		cardId: ''
	}

	if (installments) initialValues.installments = null
	if (recurrent) initialValues.recurrentPayDay = 5

	return initialValues
}

const Pix = ({ provider }) => (
	<StyledBillingInfo>
		<div className="options">
			<OnlinePayIcon />
			Você poderá realizar o pagamento via PIX pelo desktop ou smartphone.
			<br />
			Na tela de confirmação da compra será disponibilizado o QRCODE do
			pagamento. Você também receberá o mesmo por e-mail.
		</div>
		<div className="options">
			<CalendarIcon /> Verifique a validade da chave PIX, ou seja, você tem
			até o final da validade para realizar o pagamento. Após este período a
			chave perderá a validade.
		</div>

		<div style={{ marginTop: '4rem' }}>
			<h3 className="bold">IMPORTANTE:</h3>
			<ul>
				<li>
					Os pedidos são confirmados somente após a identificação do
					pagamento.
				</li>
				<li>
					Pedidos com pagamentos não realizados até a data e hora do
					vencimento serão automaticamente cancelados.
				</li>
				<li>Verifique a validade do seu QR Code.</li>
				<li>
					Para o pagamento utilize APENAS o QR Code ou link do QR Code
					fornecidos na finalização do pedido.
				</li>
				<li>
					Fique atento, evite golpes no meio de pagamento! Antes de
					finalizar o pagamento no aplicativo do banco confira se o nome do
					favorecido é: Muviflex,{' '}
					{provider === 'ITAU'
						? ' Itaú Unibanco S.A.'
						: 'MOVIM FLEXIBILIDADE DESENV GERENCIAMENTO, BCO SANTANDER (BRASIL) S.A.'}
					., CNPJ 30.715.948/0001-94. Se não aparecer esses dados, não
					finalize o pagamento
				</li>
				<li>
					NUNCA faça Transferência PIX DIRETO para a chave
					30.715.948/0001-94, pois não teremos como identificar o
					depositante com facilidade! Salientamos que a chave nº
					30.715.948/0001-94 é informada apenas para o fim de conferência
					dos dados do favorecido, que neste caso é a Muviflex. Caso ocorra
					transferência bancária ou depósito diretamente para a chave nº
					30.715.948/0001-94 faremos a devolução de valores através de
					pontos, no caso de cancelamento da compra.
				</li>
				<li>
					O Muviflex é um portal de venda de passagens de ônibus e o portal
					de venda de passagem oficial da viação PLANALTO TRANSPORTES.
				</li>
				<li>
					O cancelamento da passagem pode ser realizado desde que o pedido
					seja feito até (3) três horas antes do início da viagem.
				</li>
				<li>
					Devoluções de valores em decorrência de cancelamento de passagem
					ocorrem no prazo máximo de 30 dias após o cancelamento do pedido.
				</li>
				<li>
					Consulte os prazos de devolução de valores em termos e condições
					de uso da Muviflex:{' '}
					<Link to={routes.REGULAMENTO} target="_blank">
						www.muviflex.com.br/regulamento
					</Link>
				</li>
			</ul>
		</div>
	</StyledBillingInfo>
)

const PixLoja = () => (
	<StyledBillingInfo>
		<div className="options">
			<OnlinePayIcon />
			Você poderá realizar o pagamento via PIX pelo desktop ou smartphone.
			<br />
			Na tela de confirmação da compra será disponibilizado o QRCODE do
			pagamento. Você também receberá o mesmo por e-mail.
		</div>
		<div className="options">
			<CalendarIcon />
			Verifique a validade da chave PIX, ou seja, você tem até o final da
			validade para realizar o pagamento. Após este período a chave perderá a
			validade.
		</div>

		<div style={{ marginTop: '4rem' }}>
			<h3 className="bold">IMPORTANTE:</h3>
			<ul>
				<li>
					Os pedidos são confirmados somente após a identificação do
					pagamento.
				</li>
				<li>
					Pedidos com pagamentos não realizados até a data e hora do
					vencimento serão automaticamente cancelados.
				</li>
				<li>Verifique a validade do seu QR Code.</li>
				<li>
					Para o pagamento utilize APENAS o QR Code ou link do QR Code
					fornecidos na finalização do pedido.
				</li>
				<li>
					O Muviflex é um portal de venda de passagens de ônibus e o portal
					de venda de passagem oficial da viação PLANALTO TRANSPORTES.
				</li>
			</ul>
		</div>
	</StyledBillingInfo>
)

/**
 * @param {boolean} recurrent
 * Shows the input to select the date of the recurrent payment
 *
 * @param {boolean} noCreditCard
 * Doesn't show the creditCardButton
 *
 * @param {boolean} noDebitCard
 * Doesn't show the debitCardButton
 *
 * @param {boolean} isNotPartnerCompany
 * Doesn't show the Muvicard button
 *
 * @param {boolean} noPix
 * Doesn't show the Muvicard button
 *
 * @param {boolean} noPaymentMethodButtons
 * Doen't show payment method Buttons
 *
 * @param {boolean} noInstallments
 * Doesn't show installment options
 */
class PaymentFields extends PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			haveCreditCards: false,
			pixStatus: true,
			pixProvider: 'ITAU'
		}
	}

	selectPaymentMethod = value => {
		const { setFieldValue, setPaymentMethod } = this.props
		setPaymentMethod(value)
		setFieldValue('paymentMethod', value)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.creditCards)
			if (nextProps.creditCards.length > 0)
				this.setState({ haveCreditCards: false })
	}

	componentDidMount() {
		const { user, getCards } = this.props

		this.getPixStatusAndProvider()

		if (user) getCards()
	}

	getPixStatusAndProvider() {
		SystemConfigService.getPixStatusAndProvider().then(response => {
			this.setState({ pixStatus: response.data.isActive })
			this.setState({ pixProvider: response.data.provider })
		})
	}

	render() {
		const { haveCreditCards, pixStatus, pixProvider } = this.state
		const {
			user,
			noPix,
			values,
			errors,
			onBlur,
			touched,
			onChange,
			recurrent,
			orderValue,
			isNotPartnerCompany,
			handleBlur,
			creditCards,
			submitCount,
			noDebitCard,
			toastSuccess,
			handleChange,
			noCreditCard,
			noOnlineDebt,
			tripDateGoing,
			setFieldValue,
			noInstallments,
			setFieldTouched,
			tripGoingSummary,
			safeBoxCreditCards,
			noInstallmentsMessage,
			noPaymentMethodButtons,
			paymentMethod
		} = this.props

		const hasPublicBody = user && user.hasPublicBody
		const isOneClickBuy =
			user && user.muvicardData && user.muvicardData.oneClickBuy

		if (hasPublicBody && paymentMethod !== PAYMENT_METHODS.MUVICARD) {
			this.selectPaymentMethod(PAYMENT_METHODS.MUVICARD)
		}

		const isDebitCard = paymentMethod == 'debitCard'
		let isCreditCard = paymentMethod == 'creditCard'
		const isOnlineDebt = paymentMethod == 'onlineDebt'
		let isMuvicard = paymentMethod == 'muvicard'
		const isPix = paymentMethod == 'pix'
		const availablePaymentMethods =
			!noCreditCard +
			!noOnlineDebt +
			!noDebitCard +
			!isNotPartnerCompany +
			!noPix

		const redeemProductPath = window.location.pathname
		const hoursToBuyPix = new Date()
		hoursToBuyPix.setMinutes(5, 0, 0)

		const shouldRenderDebitFields =
			window.location.pathname === '/cliente/compra-de-passagem' ||
			window.location.pathname === '/compra-de-passagem' ||
			redeemProductPath.includes('/cliente/loja/resgatar')

		const isTicketSalePath =
			window.location.pathname === '/cliente/compra-de-passagem' ||
			window.location.pathname === '/compra-de-passagem'

		const shouldRenderMuvicard =
			window.location.pathname === '/cliente/compra-de-passagem' ||
			window.location.pathname === '/compra-de-passagem'

		const shouldRenderPix =
			window.location.pathname === '/cliente/compra-de-passagem' ||
			window.location.pathname === '/compra-de-passagem' ||
			redeemProductPath.includes('/cliente/loja/resgatar')

		const isStorePath = redeemProductPath.includes('/cliente/loja/resgatar')

		const today = new Date()
		today.setHours(0, 0, 0, 0)

		const tripDate = tripDateGoing ? new Date(tripDateGoing) : today // Mantém tripDate como Date

		let showPix =
			!noPix &&
			shouldRenderPix &&
			!isStorePath &&
			pixStatus &&
			!hasPublicBody
		let showPixStore = !noPix && shouldRenderPix && isStorePath
		let showCreditCard = !noCreditCard && !hasPublicBody

		if (!pixStatus) {
			const pixForAdmins =
				!noPix &&
				shouldRenderPix &&
				!isStorePath &&
				user != null &&
				(user.id === 'fee1ae35fff349f79ea789e1b5ad80a3' ||
					user.id === '308c11c576454f75a05a8ef71fbf4ee2' ||
					user.id === '4e4ca74f2cc14ec3985e7c61a32acaae' ||
					user.id === 'b72bca9f88c84b478008ac0683870a20' ||
					user.id === 'aa823930dda94deaa56a61e304230443' ||
					user.id === '00353458e7a5410685bf26467320b445' ||
					user.id === 'f73aa08636294f02bfddc52843d4ce9f' ||
					user.id === '31a6320e18f94037ba58405c2d1e70cb' ||
					user.id === '5da38629ae164d38b5cde9370bae8894')

			showPix = pixForAdmins
		}

		const tripDateToPix =
			tripGoingSummary && tripGoingSummary.departure
				? new Date(tripGoingSummary.departure)
				: tripDate

		const compareDatePix = new Date()
		compareDatePix.setHours(compareDatePix.getHours())

		const hasSufficientHoursToPix = compareDatePix <= tripDateToPix

		let isAdmin = false

		if (user) {
			isAdmin =
				RoleConstants.Admin == UserService.getMostImportantRole(user.roles)
		}

		return (
			<Fragment>
				{noPaymentMethodButtons || (
					<StyledPaymentMethodsButtons
						availablePaymentMethods={availablePaymentMethods}
						gap="15px">
						{showCreditCard && (
							<RadioButton
								isActive={isCreditCard}
								onClick={() => {
									this.selectPaymentMethod('creditCard')
								}}>
								<StyledContent>
									<FontAwesome
										name="credit-card"
										size={isMobile() ? '3x' : '4x'}
									/>
									<div>Cartão de crédito</div>
								</StyledContent>
							</RadioButton>
						)}

						{showPix && (
							<RadioButton
								isActive={isPix}
								sourceCall="ticketsale"
								datafor="noPossiblePix"
								onClick={() =>
									hasSufficientHoursToPix && isTicketSalePath
										? this.selectPaymentMethod('pix')
										: null
								}>
								<StyledContent>
									<img
										src={PixLogo}
										style={{
											width: isMobile() ? '60%' : '100%',
											maxHeight: 'inherit'
										}}
										alt="Pix"
									/>
								</StyledContent>
							</RadioButton>
						)}
						{showPixStore && (
							<RadioButton
								isActive={isPix}
								datafor="noPossiblePix"
								onClick={() =>
									!isTicketSalePath && isStorePath
										? this.selectPaymentMethod('pixLoja')
										: null
								}>
								<StyledContent>
									<img
										src={PixLogo}
										style={{
											width: isMobile() ? '60%' : '100%',
											maxHeight: 'inherit'
										}}
										alt="PixLoja"
									/>
								</StyledContent>
							</RadioButton>
						)}
						{isAdmin || (!isNotPartnerCompany && shouldRenderMuvicard) ? (
							<RadioButton
								isActive={isMuvicard}
								onClick={() => {
									this.selectPaymentMethod('muvicard')
								}}>
								<StyledContent>
									<img
										src={MuvicardLogo}
										style={{
											width: isMobile() ? '80%' : '100%',
											maxHeight: 'inherit'
										}}
										alt="Muvicard"
									/>
								</StyledContent>
							</RadioButton>
						) : null}
						{!noOnlineDebt && (
							<RadioButton
								isActive={isOnlineDebt}
								onClick={() => this.selectPaymentMethod('onlineDebt')}>
								<StyledContent>
									<FontAwesome
										name="credit-card"
										size={isMobile() ? '3x' : '4x'}
									/>
									<div>Débito Online</div>
								</StyledContent>
							</RadioButton>
						)}
						{!shouldRenderDebitFields ? (
							<RadioButton
								isActive={isDebitCard}
								onClick={() => {
									this.selectPaymentMethod('debitCard')
								}}>
								<StyledContent>
									<FontAwesome
										name="credit-card"
										size={isMobile() ? '3x' : '4x'}
									/>
									<div>Cartão de débito</div>
									<span>
										<img
											src={bancoSantanderLogo}
											alt="Logo Santander"
											style={{ marginTop: 5, width: 115 }}
										/>
									</span>
								</StyledContent>
							</RadioButton>
						) : null}
					</StyledPaymentMethodsButtons>
				)}
				{!shouldRenderDebitFields
					? paymentMethod === 'debitCard' &&
					!noDebitCard && (
						<DebitCardFields
							errors={errors}
							onBlur={onBlur}
							values={values}
							touched={touched}
							onChange={onChange}
							recurrent={recurrent}
							handleBlur={handleBlur}
							submitCount={submitCount}
							handleChange={handleChange}
							setFieldValue={setFieldValue}
							setFieldTouched={setFieldTouched}
						/>
					)
					: null}
				{paymentMethod === 'creditCard' &&
					showCreditCard &&
					(!noCreditCard || shouldRenderDebitFields) ? (
					!haveCreditCards || !isTicketSalePath ? (
						<CreditCardFields
							errors={errors}
							onBlur={onBlur}
							values={values}
							touched={touched}
							onChange={onChange}
							recurrent={recurrent}
							handleBlur={handleBlur}
							orderValue={orderValue}
							submitCount={submitCount}
							handleChange={handleChange}
							setFieldValue={setFieldValue}
							noInstallments={noInstallments}
							setFieldTouched={setFieldTouched}
							noInstallmentsMessage={noInstallmentsMessage}
						/>
					) : paymentMethod === 'creditCard' &&
						!noCreditCard &&
						haveCreditCards &&
						user != null &&
						showCreditCard &&
						isTicketSalePath ? (
						<SaveCreditCardFields
							errors={errors}
							onBlur={onBlur}
							values={values}
							touched={touched}
							onChange={onChange}
							recurrent={recurrent}
							orderValue={orderValue}
							handleBlur={handleBlur}
							submitCount={submitCount}
							creditCards={creditCards}
							handleChange={handleChange}
							setFieldValue={setFieldValue}
							noInstallments={noInstallments}
							setFieldTouched={setFieldTouched}
							safeBoxCreditCards={safeBoxCreditCards}
							noInstallmentsMessage={noInstallmentsMessage}
						/>
					) : null
				) : null}
				{paymentMethod === 'pix' && !noPix && (
					<Pix provider={this.state.pixProvider} />
				)}
				{paymentMethod === 'pixLoja' && !noPix && <PixLoja />}
				{paymentMethod === 'onlineDebt' && !noOnlineDebt && (
					<div style={{ marginTop: '4rem' }}>
						<p>
							Escolha o seu banco abaixo, e ao confirmar sua compra você
							será encaminhado para uma página do banco, onde deverá
							fazer o pagamento online.
						</p>
						<OnlineDebtFields
							errors={errors}
							onBlur={onBlur}
							values={values}
							touched={touched}
							onChange={onChange}
							handleBlur={handleBlur}
							submitCount={submitCount}
							handleChange={handleChange}
							setFieldValue={setFieldValue}
						/>
					</div>
				)}
				{paymentMethod === 'muvicard' &&
					(isAdmin || !isNotPartnerCompany) &&
					(user && isOneClickBuy ? (
						<MuvicardOneClick
							user={user}
							errors={errors}
							onBlur={onBlur}
							values={values}
							touched={touched}
							onChange={onChange}
							recurrent={recurrent}
							orderValue={orderValue}
							handleBlur={handleBlur}
							submitCount={submitCount}
							muvicardData={user.muvicardData}
							handleChange={handleChange}
							setFieldValue={setFieldValue}
							onCompleteCpf={cpf => {
								this.props.onCompleteCpf(cpf)
							}}
							noInstallments={noInstallments}
							setFieldTouched={setFieldTouched}
							noInstallmentsMessage={noInstallmentsMessage}
						/>
					) : (
						<MuvicardFields
							user={user}
							errors={errors}
							onBlur={onBlur}
							values={values}
							touched={touched}
							onChange={onChange}
							recurrent={recurrent}
							orderValue={orderValue}
							handleBlur={handleBlur}
							submitCount={submitCount}
							handleChange={handleChange}
							setFieldValue={setFieldValue}
							onCompleteCpf={cpf => {
								this.props.onCompleteCpf(cpf)
							}}
							noInstallments={noInstallments}
							setFieldTouched={setFieldTouched}
							noInstallmentsMessage={noInstallmentsMessage}
						/>
					))}

				{!hasSufficientHoursToPix && isTicketSalePath ? (
					<ReactTooltip
						id="noPossiblePix"
						aria-haspopup="true"
						role="example"
						effect="solid">
						Selecione outra forma de pagamento! Para compras no Pix é
						necessário uma antecedência de {hoursToBuyPix} minutos da data
						da viagem.
					</ReactTooltip>
				) : null}
			</Fragment>
		)
	}
}

const StyledBankSection = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;

	& > :nth-child(1),
	& > :nth-child(2) {
		width: calc(50% - 40px);

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex: 1;
			margin-right: 15px;
			width: calc(25% - 22.5px);
			height: 116px;
		}
	}

	& > :nth-child(1) {
		margin-right: 15px;
	}

	& > :nth-child(3) {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex: 2;
		}
	}
`

class OnlineDebtFields extends PureComponent {
	constructor(props) {
		super(props)
		this.bankOptions = {
			bancoDoBrasil: { value: 'BancoDoBrasil', label: 'Banco do Brasil' },
			bradesco: { value: 'Bradesco', label: 'Bradesco' }
		}

		this.state = {
			selectedBank: undefined
		}
	}

	selectBank = bank => {
		const { setFieldValue } = this.props
		setFieldValue('selectedBank', bank.value)
		this.setState({ selectedBank: bank })
	}

	render() {
		const { bankOptions } = this
		const { selectedBank } = this.state

		return (
			<StyledBankSection>
				<RadioButton
					style={{ flex: 1 }}
					isActive={selectedBank === bankOptions.bradesco}
					onClick={() => this.selectBank(bankOptions.bradesco)}>
					<StyledContent>
						{selectedBank === bankOptions.bradesco ? (
							<img src={bradescoLogo} alt="Logo Bradesco" />
						) : (
							<img src={bradescoLogoPB} alt="Logo Bradesco" />
						)}
						<div>{bankOptions.bradesco.label}</div>
					</StyledContent>
				</RadioButton>
				<RadioButton
					style={{ flex: 1 }}
					isActive={selectedBank === bankOptions.bancoDoBrasil}
					onClick={() => this.selectBank(bankOptions.bancoDoBrasil)}>
					<StyledContent>
						{selectedBank === bankOptions.bancoDoBrasil ? (
							<img src={bancoDoBrasilLogo} alt="Logo Banco do Brasil" />
						) : (
							<img
								src={bancoDoBrasilLogoPB}
								alt="Logo Banco do Brasil"
							/>
						)}
						<div>{bankOptions.bancoDoBrasil.label}</div>
					</StyledContent>
				</RadioButton>
				<div>
					{selectedBank && (
						<p>
							<span className="bold">
								Clientes {selectedBank.label}:
							</span>{' '}
							A forma de pagamento escolhida é valida apenas para
							clientes do {selectedBank.label}
						</p>
					)}
				</div>
			</StyledBankSection>
		)
	}
}
const mapStateToProps = store => ({
	user: store.user,
	creditCards: store.creditCards.creditCards,
	discountLabel: store.ticketSale.discountLabel,
	discountValue: store.ticketSale.discountValue,
	tripDateGoing: store.ticketSale.tripDateGoing,
	discountPercent: store.ticketSale.discountPercent,
	safeBoxCreditCards: store.creditCards.safeBoxCreditCards,
	paymentMethod: store.ticketSale.paymentMethod,
	tripGoingSummary: TicketSaleSelectors.getTripGoingSummary(store)
})

const mapDispatchToProps = {
	toastSuccess: toastActions.success,
	getCards: creditCardsActions.getCards,
	getAllCards: creditCardsActions.getAllCards,
	setPaymentMethod: TicketSaleCreators.paymentMethod
}

PaymentFields.propTypes = {
	noPix: PropTypes.bool,
	recurrent: PropTypes.bool,
	isNotPartnerCompany: PropTypes.bool,
	noDebitCard: PropTypes.bool,
	noCreditCard: PropTypes.bool,
	noPaymentMethodButtons: PropTypes.bool
}

const ConnectedPaymentFields = connect(
	mapStateToProps,
	mapDispatchToProps
)(PaymentFields)

export default ConnectedPaymentFields
